import { Controller } from "@hotwired/stimulus";
import autoAnimate from "@formkit/auto-animate";

// Connects to data-controller="auto-animate"
export default class extends Controller {
  static values = {
    duration: { type: Number, default: 250 },
    easing: { type: String, default: "ease-in-out" },
  };

  connect() {
    autoAnimate(this.element, {
      duration: this.durationValue,
      easing: this.easingValue,
    });
  }
}
